import phoneFormats from '@utils/phoneFormats';

import type { GlobalStateType } from './state';

export enum CryptoCurrencyEnum {
  ALGO = 'ALGO',
  BAT = 'BAT',
  BCH = 'BCH',
  BTC = 'BTC',
  DAI = 'DAI',
  INJ = 'INJ',
  EGLD = 'EGLD',
  ETH = 'ETH',
  OKB = 'OKB',
  TRX = 'TRX',
  USDT = 'USDT',
  TON = 'TON',
  MATIC = 'MATIC',
  BNB = 'BNB',
  BUSD = 'BUSD',
  '1INCH' = '1INCH',
  ADA = 'ADA',
  NEAR = 'NEAR',
  LTC = 'LTC',
  USDC = 'USDC',
}

export enum FiatCurrencyEnum {
  EUR = 'EUR',
  RUB = 'RUB',
  USD = 'USD',
  JPY = 'JPY',
  TRY = 'TRY',
  GBP = 'GBP',
  UAH = 'UAH',
  IDR = 'IDR',
}

export enum NetworkEnum {
  ALGORAND = 'ALGORAND',
  ARBITRUM = 'ARBITRUM',
  AVALANCHE = 'AVALANCHE',
  BINANCESMARTCHAIN = 'BINANCESMARTCHAIN',
  BITCOIN = 'BITCOIN',
  BITCOINCASH = 'BITCOINCASH',
  CARDANO = 'CARDANO',
  COSMOS = 'COSMOS',
  CRONOS = 'CRONOS',
  DASH = 'DASH',
  DOGECOIN = 'DOGECOIN',
  ETHEREUM = 'ETHEREUM',
  FANTOM = 'FANTOM',
  FLOW = 'FLOW',
  KAVA = 'KAVA',
  KUSAMA = 'KUSAMA',
  LITECOIN = 'LITECOIN',
  NEAR_PROTOCOL = 'NEAR_PROTOCOL',
  NEWTON = 'NEWTON',
  OPTIMISM = 'OPTIMISM',
  POLKADOT = 'POLKADOT',
  POLYGON = 'POLYGON',
  RIPPLE = 'RIPPLE',
  SOLANA = 'SOLANA',
  STELLAR = 'STELLAR',
  TERRA = 'TERRA',
  TEZOS = 'TEZOS',
  TRON = 'TRON',
  DEFAULT = 'DEFAULT',
}

export enum EEACountryCodes {
  AT = 'at',
  BE = 'be',
  BG = 'bg',
  HR = 'hr',
  CY = 'cy',
  CZ = 'cz',
  DK = 'dk',
  EE = 'ee',
  FI = 'fi',
  FR = 'fr',
  DE = 'de',
  GR = 'gr',
  HU = 'hu',
  IS = 'is',
  IE = 'ie',
  IT = 'it',
  LV = 'lv',
  LT = 'lt',
  LU = 'lu',
  MT = 'mt',
  NL = 'nl',
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  RO = 'ro',
  SK = 'sk',
  SI = 'si',
  ES = 'es',
  SE = 'se',
  LI = 'li',
}

export enum EEAExcludeCryptoCurrencyEnum {
  DAI = 'DAI',
  USDT = 'USDT',
}

export enum ZHModalTypeEnum {
  buy = 'buy',
  bind = 'bind',
}

export type PhoneFormatsType = keyof typeof phoneFormats;

export type CurrencyEnum = CryptoCurrencyEnum | FiatCurrencyEnum;

export type Country = {
  code: PhoneFormatsType;
  code3: string;
  title: string;
  phone_prefix: string;
  phone_mask: string;
};

// public/data-by-ip

export type DataByIpResponse = {
  country: Country;
};

// lib/currencies

export type CurrencyDisplayOptionsType = {
  [key in CurrencyEnum]?: {
    display_digits: number;
    fullname: string;
    total_digits: number;
  };
};
export type CurrencyIconsType = {
  [key in CurrencyEnum]?: {
    svg: string;
    png: string;
    relative: {
      png: string;
      svg: string;
    };
  };
};

export type CurrencyConfigType = {
  display_options: CurrencyDisplayOptionsType;
  icons: CurrencyIconsType;
  base: {
    [key in CryptoCurrencyEnum]?: BaseCurrencyEnum;
  };
  has_withdrawal_fee: { [key in CryptoCurrencyEnum]?: boolean };
  default_networks: {
    [key in CryptoCurrencyEnum]?: NetworkEnum;
  };
};

export type Currencies = {
  fiat: FiatCurrencyEnum[];
  crypto: CryptoCurrencyEnum[];
  config: CurrencyConfigType;
};

export type VerificationType = {
  timeout: string;
};

export enum BaseCurrencyEnum {
  ETH = 'ETH',
  BCH = 'BCH',
  BTC = 'BTC',
  TONCOIN = 'TONCOIN',
  TRX = 'TRX',
  ALGO = 'ALGO',
  BNB = 'BNB',
  USDC = 'USDC',
}

export enum BaseNetworkEnum {
  'ERC-20' = 'ERC-20',
  'BEP-20' = 'BEP-20',
  'BSC' = 'BSC',
  'TRC-20' = 'TRC-20',
}

// lib/iban-purposes

export type IbanPurposes = {
  name: string;
}[];

// calc-log/start

export type CalcStartResponse = {
  xCalcId: string;
};

export type RedirectToType =
  | keyof typeof CONST.nav
  | {
      search?: GlobalStateType['redirect']['search'];
      state?: GlobalStateType['redirect']['state'];
      to: keyof typeof CONST.nav;
    };

// /lib/states
export type GetStatesParams = {
  country_code?: string;
};

export type States = { name: string; code: string; is_active: boolean }[];
